import { css } from '@emotion/core';
import { findLastIndex } from 'lodash';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';
import Watermark from './Watermark.png';

export const containerSizesShop = {
  // background: 'url(https://newstore.ictpvtltd.com/feature/Watermark.png)',
  background: `url(${Watermark})`,
  backgroundPosition: 'right -21px bottom 10px',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  height: '100%',
  display: 'flex',
  width: '100%',
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    backgroundPosition: 'unset',
    paddingTop: '0px',
    backgroundRepeat: 'repeat',
  },
  [MediaQueries.md]: {
    backgroundPosition: 'right 10px bottom 10px',
  },

  [MediaQueries.lg]: {
    backgroundPosition: 'right 10px bottom 10px',
  },
};

export const FeatureBulletLink = {};

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',

  '.style-ImageText': {
    margin: '128px 111px',
    justifyContent: 'space-between',
    display: 'flex',

    [MediaQueries.lg]: {
      margin: '96px 0px',
      justifyContent: 'space-between',
    },
    [MediaQueries.lgAndLandscape]: {
      margin: '96px 0px',
      justifyContent: 'space-around',
    },
    [MediaQueries.md]: {
      margin: '96px 0px',
      justifyContent: 'space-around',
    },
    [MediaQueries.sm]: {
      margin: '64px 0px 0px',
      justifyContent: 'space-between',
    },
    '.imgsec': {
      paddingLeft: '0px',
      [MediaQueries.lg]: {
        marginLeft: '0%',
      },
      [MediaQueries.md]: {
        marginLeft: '0%',
        marginRight: '0%',
      },

      [MediaQueries.sm]: {
        marginLeft: '0%',
        marginRight: '0%',
        width: '100%',
        order: '2',
      },

      '.img1': {
        [MediaQueries.sm]: {
          width: '90%',
          marginTop: '32px',
        },

        img: {
          [MediaQueries.sm]: {
            width: '240px',
            height: '240px',
            justifyContent: 'space-between',
          },
          [MediaQueries.xl]: {
            width: '448px',
            height: '448px',
          },
          [MediaQueries.lg]: {
            width: '400px',
            height: '400px',
          },
          [MediaQueries.md]: {
            width: '232px',
            height: '232px',
            justifyContent: 'space-between',
          },
        },
      },
      '.img2': {
        position: 'relative',
        top: '0px',
        marginTop: '-164px',
        left: '304px',
        width: '100%',
        [MediaQueries.sm]: {
          width: '50%',
          position: 'relative',
          marginTop: '-115px',
          left: '165px',
        },
        [MediaQueries.md]: {
          marginTop: '-100px',
          left: '150px',
        },
        [MediaQueries.lg]: {
          marginTop: '-140px',
        },

        img: {
          objectFit: 'cover',

          [MediaQueries.sm]: {
            width: '152px',
            height: '152px',
          },
          [MediaQueries.xl]: {
            width: '256px',
            height: '256px',
          },
          [MediaQueries.lg]: {
            width: '200px',
            height: '200px',
          },
          [MediaQueries.md]: {
            width: '144px',
            height: '144px',
          },
        },
      },
      img: {},
    },
  },

  '.style-TextImage': {
    margin: '128px 111px',
    display: 'flex',
    overflow: 'hidden',
    justifyContent: 'space-between',
    [MediaQueries.sm]: {
      margin: '64px 0',
    },

    [MediaQueries.lg]: {
      margin: '96px 0px',
      justifyContent: 'space-around',
    },
    [MediaQueries.md]: {
      margin: '96px 0px',
      justifyContent: 'space-around',
    },

    '.imgsec': {
      marginRight: '0px',
      position: 'relative',
      right: '-20px',
      [MediaQueries.sm]: {
        marginLeft: '0%',
        marginRight: '0%',
        width: '100%',
        paddingLeft: '0px',
        order: '2',
        right: '0',
      },

      [MediaQueries.md]: {
        marginLeft: '0%',
      },

      '.img1': {
        [MediaQueries.sm]: {
          marginTop: '32px',
        },
        img: {
          [MediaQueries.sm]: {
            width: '240px',
            height: '240px',
          },

          [MediaQueries.xl]: {
            width: '448px',
            height: '448px',
          },

          [MediaQueries.lg]: {
            width: '400px',
            height: '400px',
          },
          [MediaQueries.md]: {
            width: '232px',
            height: '232px',
          },
        },
      },
      '.img2': {
        position: 'relative',
        marginTop: '-164px',
        left: '-87px',
        width: '100%',
        [MediaQueries.sm]: {
          width: '50%',
          position: 'relative',
          marginTop: '-115px',
          left: '165px',
        },

        [MediaQueries.lg]: {
          marginTop: '-140px',
        },
        [MediaQueries.md]: {
          marginTop: '-100px',
        },

        img: {
          [MediaQueries.sm]: {
            width: '152px',
            height: '152px',
          },
          [MediaQueries.xl]: {
            width: '256px',
            height: '256px',
          },
          [MediaQueries.lg]: {
            width: '200px',
            height: '200px',
          },
          [MediaQueries.md]: {
            width: '144px',
            height: '144px',
          },
        },
      },
    },
    '.contentsec': {
      [MediaQueries.lg]: {
        maxWidth: '350px',
        marginLeft: '0px',
        [MediaQueries.lgAndLandscape]: {
          marginLeft: '60px',
        },
      },
      [MediaQueries.md]: {
        maxWidth: '300px',
        marginLeft: '0px',
      },
      [MediaQueries.sm]: {
        order: '2',
      },
    },
  },

  '.contentsec': {
    marginLeft: '0',
    paddingLeft: '0px',
    paddingTop: '80px',
    paddingRight: '0px',

    [MediaQueries.lg]: {
      maxWidth: '350px',
      marginLeft: '0px',
      [MediaQueries.lgAndLandscape]: {
        marginLeft: '60px',
      },
    },
    [MediaQueries.sm]: {
      paddingTop: '0px',
    },
    [MediaQueries.md]: {
      paddingTop: '0px',
      maxWidth: '300px',
      marginLeft: '0px',
    },

    img: {},

    h2: {
      fontSize: '58px',
      fontWeight: '500',
      lineHeight: '56px',
      letterSpacing: '-1px',
      maxWidth: '420px',
      marginBottom: '24px',

      [MediaQueries.sm]: {
        fontSize: '32px',
        fontWeight: '500',
        lineHeight: '32px',
        letterSpacing: '-4px',
        letterSpacing: 'unset',
        marginBottom: '24px',
      },
      [MediaQueries.lg]: {
        fontSize: '48px',
        lineHeight: '48px',
        letterSpacing: '-1px',
        textAlign: 'left',
      },
      [MediaQueries.md]: {
        fontSize: '48px',
        lineHeight: '48px',
        letterSpacing: '-1px',
        textAlign: 'left',
      },
    },

    p: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'center',
    },

    '.listsec': {
      maxWidth: '450px',
      ul: {
        li: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          alignItems: 'flex-start',
          display: 'flex',
          marginBottom: '24px',
          paddingRight: '10px',
          verticalAlign: 'middle',

          '.icon_img': {
            display: 'inline-block',
            height: '18px',
            margin: '3px 13px 0 0',
            minWidth: '18px',
            verticalAlign: 'middle',
            width: '18px',
          },
        },
      },
    },

    '.cta': {
      [MediaQueries.md]: {
        paddingBottom: '8px',
      },
      a: {
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '32px',
        letterSpacing: '0px',
        textAlign: 'left',
        color: colorsPalette.red,
        textDecoration: 'none',
        fontWeight: '400',
        borderBottom: `1px solid ${colorsPalette.red}`,

        span: { paddingBottom: '5px', borderBottom: '#FAD3CC solid 1px' },
      },
    },
  },
});
